import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import firebase from "firebase";
import { toast } from "react-toastify";
import { faLink, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { deleteLinkAction } from "../../../../../store/actions/actions";

const DisplayLink = ({ project_id, section_id, isAdmin }) => {
  const linksDataList = useSelector((state) => state.links);
  const dispatch = useDispatch();

  const deleteLink = async (proj, sec, linkId) => {
    try {
      await firebase
        .firestore()
        .collection("projects")
        .doc(proj)
        .collection("section")
        .doc(sec)
        .collection("links")
        .doc(linkId)
        .delete();

      dispatch(deleteLinkAction({ id: linkId }));
      toast.success("Link deleted successfully");
    } catch (error) {
      toast.error("Error deleting link: " + error.message);
    }
  };

  const displayLinks = linksDataList
    ? linksDataList.filter(
        (data) =>
          data &&
          // data.project_id === project_id &&
          data.section_id === section_id
      )
    : [];

  return (
    <div>
      <span style={{ fontSize: "0.9rem", fontWeight: "bold" }}>Links</span>
      {displayLinks.length ? (
        <ul style={{ paddingLeft: 0 }}>
          {displayLinks.map((link) => (
            <li
              key={link.id}
              style={{
                marginBottom: 10,
                display: "flex",
                alignItems: "center",
              }}
            >
              <FontAwesomeIcon
                icon={faLink}
                style={{ fontSize: ".8rem", marginRight: 5 }}
              />

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexGrow: 1,
                  minWidth: 0,
                }}
              >
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener"
                  title={link.url}
                  style={{
                    fontSize: ".85rem",
                    color: "#007bff",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "250px",
                    display: "inline-block",
                  }}
                >
                  {link.url}
                </a>

                {isAdmin ? (
                  <FontAwesomeIcon
                    icon={faTrashAlt}
                    style={{
                      fontSize: ".85rem",
                      color: "red",
                      cursor: "pointer",
                      marginLeft: 8,
                      flexShrink: 0,
                    }}
                    onClick={() =>
                      deleteLink(link.project_id, link.section_id, link.id)
                    }
                  />
                ) : null}
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p style={{ fontSize: ".8rem", color: "#888" }}>No links available.</p>
      )}
    </div>
  );
};

export default DisplayLink;
